import { createAsyncThunk, createListenerMiddleware, createSlice } from '@reduxjs/toolkit';
import Notifications from 'react-notification-system-redux';
import { ApplicationState, TypedListener } from "@/store";
import { apiClient } from '@/utils';
import * as actions from '@/store/actions';
import { CreateServicePrice, CreateServiceQuery, Service, SimilarService } from '@/types';
import bmApi from '@/services/bmApi';
import { getTranslate } from 'react-localize-redux';
import { parse } from '@/utils/datetime';
import { push } from 'connected-react-router';


// Middlewares
export const similarServiceListener = createListenerMiddleware();
export const startSimilarServiceListener = similarServiceListener.startListening as TypedListener;


// Thunks
export const createSimilarService = createAsyncThunk(
    'similarService/create',
    async (similarService: SimilarService, thunkApi) => {
        try {
            const state = thunkApi.getState() as ApplicationState;

            const translate = getTranslate(state.localize);
            // const systemSettings: SystemSettings | undefined = state.settings?.systemSettings?.data;
            // const currencyId = systemSettings?.DefaultLanguage;
            // const { data: currencies } = await apiClient.get('/currencies?Active=true');



            const service: CreateServiceQuery = {
                Name: similarService.Name,
                Description: similarService.Description,
                Duration: similarService.SuggestedDurationMinutes,
                DurationTypeId: 1,
                // @ts-ignore
                ScheduleTypeId: 1,
                "CustomFields": [],
                "ResourceTypes": [],
                "Schedules": {
                    "RecurringSchedules": []
                },
                // @ts-ignore
                "CustomFieldValues": []
            }
            const { data: serviceData } = await apiClient.post<Service>('/services', service);

            const price: CreateServicePrice = {
                Price: similarService.SuggestedPrice,
                CalculationTypeId: 1,
                ServiceId: serviceData.Id,
                VAT: 0.25,
                CurrencyId: 'SEK',
                From: new Date().toISOString(),
                To: parse('9999-12-31', 'yyyy-MM-d', new Date()).toISOString(),
            }


            const createPriceResponse = await apiClient.post<Service>('/services/prices', price);

            thunkApi.dispatch(Notifications.show({ title: translate('similarService.create.success', { serviceName: serviceData.Name }) as string }, 'success'));
            thunkApi.dispatch(push(`/services/${serviceData.Id}`))
            return thunkApi.fulfillWithValue([serviceData, createPriceResponse.data]);
        } catch (error: any) {
            thunkApi.dispatch(Notifications.show({ title: error.message as string }, 'error'));

            return thunkApi.rejectWithValue(error);
        }

    }
)

interface InitialState {
    entity?: Service | null
    error?: any
    isError: boolean
    isLoading: boolean
    isSuccess: boolean,
}
const initialState: InitialState = {
    entity: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
}

export const similarServiceSlice = createSlice({
    name: 'similarService',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addMatcher(createSimilarService.pending.match, (state, action) => {
            state.isLoading = true;
        })
        builder.addMatcher(createSimilarService.rejected.match, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload;
        })
        builder.addMatcher(createSimilarService.fulfilled.match, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.error = undefined;
            // state.entity = action.payload;
        })
    },
})
// Listeners
startSimilarServiceListener({
    type: actions.CREATE_SERVICE.SUCCESS,
    effect: async (action, api) => {
        api.dispatch(bmApi.util.invalidateTags(['similarServices']));
    }
});

startSimilarServiceListener({
    type: actions.EDIT_SERVICE.SUCCESS,
    effect: async (action, api) => {
        api.dispatch(bmApi.util.invalidateTags(['similarServices']));
    }
});

